import { create } from 'zustand';

interface PlayerAccessState {
  authorizedQcastId: string | null;
  authorizeQcast: (qcastId: string) => void;
  clearPlayerAccess: () => void;
}

export const usePlayerAccessStore = create<PlayerAccessState>((set) => ({
  authorizedQcastId: null,
  authorizeQcast: (qcastId) => set({ authorizedQcastId: qcastId }),
  clearPlayerAccess: () => set({ authorizedQcastId: null }),
}));